import { FC, PropsWithChildren, useLayoutEffect } from 'react';
import { setGlobalStoreCookie } from './stores/global.store';

export const WithCaptureURLState: FC<PropsWithChildren> = ({ children }) => {
	useLayoutEffect(() => {
		const url = new URL(window.location.href);
		const state = url.searchParams.get('__state');
		if (!state) return;

		const stateJSON = atob(state);
		const stateObj = JSON.parse(stateJSON) as { token: string; selectedCompanyID: string };
		setGlobalStoreCookie(() => {
			return {
				token: stateObj.token,
				selectedCompanyID: stateObj.selectedCompanyID,
			};
		});

		url.searchParams.delete('__state');
		window.history.replaceState({}, '', url.toString());
	}, []);

	return <>{children}</>;
};
